package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
data class UploadUrlResponse(
    val uploadUrl: String,
    val publicUrl: String,
    val fileKey: String
)

@Serializable
data class FileRegistrationResponse(
    val mediaId: String,
    val publicUrl: String
)

@Serializable
data class FileRegistrationRequest(
    val fileKey: String,
    val type: ImageType
)